"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getNextQueueRoute = void 0;
exports.getNextQueueRoute = '/queue/getNextQueue';
//# sourceMappingURL=getNextQueue.route.js.map